var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.427 24.1195L90.2719 3.41171C88.4042 1.48241 85.9009 0.299107 83.2161 0.0675913C82.814 0.0161433 82.412 -0.00958463 81.9969 0.00327737H5.65496C2.52917 0.00327737 0 2.51137 0 5.61111V50.3452C0 53.4449 2.52917 55.953 5.65496 55.953H81.2317C84.6039 56.2617 87.9242 55.0398 90.2589 52.6089L110.414 31.8882C112.529 29.7145 112.529 26.2803 110.414 24.1067L110.427 24.1195Z",
    fill: "#336461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0216 23.6055V25.5091H17.8076V28.03H22.5676V29.895H17.8076V32.5189H23.0216V34.4225H15.7583V23.6184H23.0216V23.6055ZM19.5456 20.2871H21.971L20.1811 22.5508H18.6377L19.5456 20.2871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2124 23.6053H30.4147C33.761 23.5539 36.1086 25.9076 36.0567 29.0074C36.1086 32.1071 33.748 34.448 30.4147 34.4094H26.2124V23.6053ZM30.1942 32.5058C32.6066 32.5058 33.9426 31.1167 33.9426 29.0202C33.9426 26.9237 32.6066 25.5089 30.1942 25.5089H28.2746V32.5058H30.1942Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1799 23.6055V34.4095H39.1177V23.6055H41.1799Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8516 25.4576V23.6055H52.5156V25.4576H49.2212V34.4095H47.1719V25.4576H43.8645H43.8516Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2627 23.6055V34.4095H55.1875V23.6055H57.2627Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0434 23.3742C69.4157 23.3099 71.8281 25.9852 71.7892 29.0077C71.8411 32.056 69.4286 34.6927 66.0434 34.6413C62.6582 34.7056 60.2588 32.0689 60.2977 29.0077C60.2458 25.9852 62.6453 23.3099 66.0434 23.3742ZM66.0434 25.3163C63.7737 25.3163 62.4248 27.0399 62.4248 29.0077C62.4248 30.9756 63.7737 32.6991 66.0434 32.6991C68.3132 32.6991 69.688 30.9885 69.688 29.0077C69.688 27.027 68.3002 25.3163 66.0434 25.3163Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8994 27.4773V34.397H74.8242V23.5029H76.0045L82.2431 30.5256V23.6058H84.3313V34.4999H83.151L76.8994 27.4773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdition);
export default __webpack_public_path__ + "static/media/edition.0153248bdf3f2358f369089373ffce7c.svg";
export { ForwardRef as ReactComponent };